import { CONTENT_ALIAS } from './const.config';

// Define page-title configurations
const PAGE_TITLE_LIST = {
  OVERVIEW_DASHBOARD: 'Overview Dashboard',
  SUBSCRIBERS: 'Subscribers',
  ADMIN_USERS: 'CMS Users',
  CONTENT_CHANNELS: `Content / ${CONTENT_ALIAS.CHANNEL_PLURAL}`,
  CONTENT_CATEGORIES: `Content / ${CONTENT_ALIAS.CATEGORY_PLURAL}`,
  CONTENT_VIDEOS: `Content / ${CONTENT_ALIAS.VIDEO_PLURAL}`,
  CONTENT_SEQUENCE: 'Content / Sequence',
  CONTENT_TABS: 'Content / Tabs',
  CONTENT_COLLECTIONS: `Content / ${CONTENT_ALIAS.COLLECTION_PLURAL}`,
  REPORTS_OVERVIEW_VIDEOS: `Analytics Reports / Overview (${CONTENT_ALIAS.VIDEO_PLURAL})`,
  REPORTS_WATCH_SESSIONS: 'Analytics Reports / Watch Sessions',
  REPORTS_VIDEO_WATCH_SESSIONS: 'Analytics Reports / Videos',
  REPORTS_APP_SESSIONS: 'Analytics Reports / App Sessions',
  LOGIN: 'Login',
  LOGOUT: 'Logout',
  ERROR_NOT_FOUND: '404 Not Found',
};

export default PAGE_TITLE_LIST;
